import React, { useEffect, useRef } from 'react';

export const ScrollOnMount = () => {
  const elRef = useRef(null);
  const executeScroll = () =>
    elRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

  useEffect(() => {
    executeScroll();
  }, []);

  return (
    <div
      data-testid="scroolInto_container"
      ref={elRef}
      onClick={executeScroll}
    ></div>
  );
};
